import PhoneInput from "react-phone-number-input";
import styled from "styled-components";
import { designSystemVars as vars } from "../tokens";

export const PhoneInputControl = styled(PhoneInput)`
  position: relative;
  display: flex;
  width: 100%;
  height: ${vars.spacing["3xl"]};
  align-items: center;
  gap: var(--inzeloop-ds-spacing-sm);
  border-radius: ${vars.radius.control};
  padding: 0 var(--inzeloop-ds-spacing-10px);

  .PhoneInputCountry {
    position: relative;
    display: flex;
    align-items: center;
    gap: var(--inzeloop-ds-spacing-6px);
    cursor: default;
  }

  .PhoneInputCountryIcon {
    width: ${vars.spacing.px20} !important;
    height: ${vars.spacing.px14} !important;
  }

  .PhoneInputCountrySelectArrow {
    display: block !important;
    visibility: visible !important;
    width: 0;
    height: 0;
    margin-left: ${vars.spacing.xs};
    border-top: ${vars.spacing.px5} solid ${vars.color.text.quiet};
    border-right: ${vars.spacing.px5} solid ${vars.color.border.transparent};
    border-left: ${vars.spacing.px5} solid ${vars.color.border.transparent};
    opacity: 1 !important;
    content: "";
  }

  .PhoneInputCountrySelect {
    position: absolute;
    z-index: ${vars.zIndex.dropdown};
    width: 100%;
    height: 100%;
    cursor: default;
    opacity: 0;
  }

  .PhoneInputInput {
    height: ${vars.spacing.px20};
    flex: 1;
    border: 0;
    outline: 0;
    background: ${vars.color.background.transparent};
    padding: 0;
    font-size: ${vars.typography.size.px14};

    &:focus {
      outline: 0;
    }
  }
`;
